<ion-app>
  <ion-split-pane contentId="main-content" when="lg">
    <ion-menu style="--background: url(assets/bg1.jpg) no-repeat top/cover;" contentId="main-content" type="overlay">
     <ion-header>
      <div class="menu-header">
        <ion-item lines="none" class="user-logged" *ngIf="userService.currentUser">
          <ion-avatar slot="start" style="margin-right: 0;">
            <img [src]="userService.currentUser.avatar || 'assets/user-orange.png'">
          </ion-avatar>
          <ion-label>
            <ion-list-header class="primary">
              <span *ngIf="userService.currentUser.fullname">{{userService.currentUser.fullname}}</span>&nbsp;
            </ion-list-header>
            <ng-container *ngIf="userService.currentUser.email">
              <ion-note>{{userService.currentUser.email}}</ion-note><br>
            </ng-container>
            <ion-note color="tertiary">{{userService.currentUser.profil && userService.currentUser.profil.name}}
            </ion-note>
          </ion-label>
        </ion-item>
        <ion-toolbar>
          <ion-buttons slot="start">
            <ion-button  (click)="showThemeChoose()">
              <ion-icon slot="icon-only" [name]="toggle === 'LIGHT' ? 'sunny': 'moon'"></ion-icon>
            </ion-button>
          </ion-buttons>
          <ion-item lines="none" class="lang-select" *ngIf="userService.currentUser">
            
            <ion-select multiple="false" (ionChange)="updateLanguage()" [(ngModel)]="language"  >
              
              <ion-select-option value="en">ENG</ion-select-option>
              <ion-select-option value="fr">FR</ion-select-option> 
          
            </ion-select>
          </ion-item>
        </ion-toolbar>
      </div>
    </ion-header>
      <ion-content  class="ion-no-padding" style="--background: transparent">
        <ion-list id="inbox-list">
          <app-menu-item  *ngFor="let p of ui.activatedServices" [item]="p"></app-menu-item>
        </ion-list>
      </ion-content>
      <ion-footer class="ion-no-border">
        <ion-menu-toggle auto-hide="false">
          <ion-item style="border-radius: 0px;" mode="md" lines="none" button (click)="logout()">
            <ion-icon slot="start" name="log-out"></ion-icon>
            <ion-label>
             {{'LOGOUT' | translate}} 
            </ion-label>
          </ion-item>
        </ion-menu-toggle>
      </ion-footer>
    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>